module.exports = __webpack_public_path__ + "static/media/kioskStraight.5c999432.png";